import { account } from '@/appwrite.js'
import { useAppDispatch } from "@store/hooks";
import { setAuth } from "@store/slices/authSlice";

const useAuth = () => {
    const dispath = useAppDispatch();

    const signUserIn = async (email: string, password: string) => {
        try {
            const result = await account.createEmailPasswordSession({ email, password });

            if(result.userId) {
                dispath(setAuth(true));
                return {
                    success: true,
                    message: 'User is authenticated',
                    data: result.$id
                };
            }else {
                dispath(setAuth(false));
                return {
                    success: false,
                    message: 'Failed to log in. Please try again.',
                    data: null
                };
            }

        }catch (error: any) {
            console.error('Error logging in:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        }
    };

    const checkUserPresence = async () => {
        try {
            const result = await account.get();
            
            if(result.status) {
                dispath(setAuth(true));
                return {
                    success: true,
                    message: 'User is authenticated',
                    data: result.$id
                };
            }else {
                dispath(setAuth(false));
                return {
                    success: false,
                    message: 'User is not authenticated',
                    data: null
                };
            }
        }catch (error) {
            console.error('Error getting user:', error);
            dispath(setAuth(false));
            return {
                success: false,
                message: 'Failed to check presence. Please try again',
                data: null
            };
        }
    };

    const signUserOut = async () => {
        try {
            await account.deleteSession({ sessionId: "current" });

            dispath(setAuth(false));
        }catch (error) {
            console.error('Error getting user:', error);
            return {
                success: false,
                message: 'Failed to check presence. Please try again',
                data: null
            }
        }
    };

    return {
        checkUserPresence,
        signUserIn,
        signUserOut
    }
};

export default useAuth;